jQuery( '.staggered-section .staggered-slider' ).slick( {
    dots: false,
    infinite: false,
    speed: 600,
    cssEase: 'ease',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
} );

jQuery( '.staggered-section .play-video' ).on( 'click', function() {
    var video = jQuery( this ).siblings( 'video' );
    jQuery( video ).get( 0 ).play();

    jQuery( video ).attr( 'controls', true );

    jQuery( this ).fadeOut();
} );